import { getSessionAuthentication, baseUrl } from '../common/Api';

interface FetchOptions {
    method: string;
    headers: Record<string, string>;
    body?: string;
}

function getHeaders(): Record<string, string> {
    const auth = getSessionAuthentication();
    return {
        'Content-Type': 'application/json',
        'Authorization': auth.token,
        'x-cleverapps-tenant': auth.tenantStringIdentifier,
    };
}

async function legacyFetch<T>(path: string, options?: Partial<FetchOptions>): Promise<T> {
    const response = await fetch(baseUrl + path, {
        method: options?.method ?? 'GET',
        headers: getHeaders(),
        body: options?.body,
    });
    if (!response.ok) {
        const text = await response.text();
        let message = `API error: ${response.status} ${response.statusText}`;
        try {
            const parsed = JSON.parse(text);
            if (parsed?.message) message = parsed.message;
        } catch { /* ignore */ }
        throw new Error(message);
    }
    const text = await response.text();
    return text ? JSON.parse(text) : null;
}

export interface MainGroup {
    id: number;
    mainGroupCode: string;
    mainGroupDescription: string;
}

export interface Department {
    id: number;
    departmentCode: string;
    departmentDescription: string;
    mainGroups: MainGroup[];
}

export async function getDepartment(id: number): Promise<Department> {
    return legacyFetch<Department>(`departments/${id}`);
}

export async function saveDepartment(d: Department): Promise<Department> {
    return legacyFetch<Department>('departments/save', {
        method: 'POST',
        body: JSON.stringify(d),
    });
}

export async function getMainGroups(): Promise<MainGroup[]> {
    return legacyFetch<MainGroup[]>('departments/maingroups');
}
